import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';
import { defineAuthProvider } from '@zg-rentals/auth-react';
import { getClient } from '@zg-rentals/ts-client-http-client';
import { isAuthorized } from '@zg-rentals/auth-comet';

const httpClient = getClient().extend({
  prefixUrl: __DEV__ ? '/rental-manager/payments/proxy' : process.env.NEXT_PUBLIC_RENTAL_MANAGER_PREFIX_URL,
});

export const Auth = defineAuthProvider({
  queryOptions: () => RentalManagerUserInfoV2WebApiHandler_get_queryOptions({}, { httpClient }),

  isAuthorized: isAuthorized({
    mapUser: (user) => ({ ...user, isLoggedIn: user.loggedIn }),
  }),
});

export const { useAuth } = Auth;
